import { render, staticRenderFns } from "./GlobalParamForm.vue?vue&type=template&id=9817c922&scoped=true"
import script from "./GlobalParamForm.vue?vue&type=script&lang=ts"
export * from "./GlobalParamForm.vue?vue&type=script&lang=ts"
import style0 from "./GlobalParamForm.vue?vue&type=style&index=0&id=9817c922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9817c922",
  null
  
)

export default component.exports